import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import Intro from './components/pages/Intro';
import Navigation from './components/Navigation';
import BackgroundCircles from './components/BackgroundCircles';
import Cursor from './components/Cursor';
import Footer from './components/Footer';
import Investifi from './components/pages/projects/Investifi';
import PageTransition from './components/PageTransition';
import { trackPageView } from './utils/analytics';

// Component to track page views on route changes
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <PageTracker />
      <Cursor />
      <BackgroundCircles />
      <Navigation />
      <PageTransition>
        <Routes>
          <Route path="/" element={<Intro />} />
          <Route path="/projects" element={<Navigate to="/projects/investifi" replace />} />
          <Route path="/projects/investifi" element={<Investifi />} />
        </Routes>
      </PageTransition>
      <Footer />
    </Router>
  );
}

export default App;
